var _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetalValance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 436.8 566.9",
    enableBackground: "new 0 0 436.8 566.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M37.9,552"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M395,457.1c0,0,1.3-4.3,1.3-8.6c-0.1-7.8-0.7-20.6-0.7-20.6 l-1.7-5.4V74.4L33.6,154.9v361.8l2.9,6.4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    points: "33.6,192.4 393.9,109.6 393.9,141.7 33.6,226.6 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    points: "33.6,277.3 393.9,190.2 393.9,223.1 33.6,313.3 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    points: "33.6,358.6 393.9,270.9 393.9,302.3 33.6,392.1 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    points: "33.6,442.1 393.9,351.5 393.9,384.3 33.6,478.5 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M33.7,516.9L394,422.8l1.7,5.4l0.9,27.1c0,0,0,3.3-6.1,4.6 c-8.7,1.9-353.9,92.6-353.9,92l0.1-28.6L33.7,516.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M33.6,516.9l-1.6,5.2v21.8l0.7,3.4c0,0,3.8,4.9,3.8,4.6 c0-10.1,0-28.7,0-28.6L33.6,516.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M59.3,154.7c0,0,330-77.7,339-77.7c9,0,22.8-11.9,21.4-35.2 c-1.4-23.3-17.1-24.3-17.1-24.3L60.5,87.5L46.2,88v66.7H59.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M17,154.7h41.7c0,0,9.5-6.1,11.4-28.2C72.6,98.2,60.5,88,60.5,88 H33.6h-7.7H17V154.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M60.5,88H17.7c-0.1,0-0.8-0.3-0.7-0.3L368.5,15l33.2,2.6 c0.1,0,0.1,0.1,0,0.1L60.5,88z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetalValance);
export default __webpack_public_path__ + "static/media/metal_valance.73ae2ad29e99bab8ddc3787bf1dd0493.svg";
export { ForwardRef as ReactComponent };